import * as charts from './charts';
import * as table from './table';

export const phoneAnalyticsDemoData = {
  charts,
  table,
};
